import type {
	ReviewablePortfolio,
	ReviewablePortfolioDetail,
	ReviewablePortfolioProject,
} from "@shared/types";
import { apiClient } from "@/lib/api-client";

export type {
	ReviewablePortfolio,
	ReviewablePortfolioDetail,
	ReviewablePortfolioProject,
};

export async function listPendingPortfolios(): Promise<ReviewablePortfolio[]> {
	const response = await apiClient.get("/api/v1/admin/portfolios/pending");
	return response.data.data.portfolios as ReviewablePortfolio[];
}

export async function getPortfolioForReview(
	id: string,
): Promise<ReviewablePortfolioDetail> {
	const response = await apiClient.get(`/api/v1/admin/portfolios/${id}`);
	return response.data.data as ReviewablePortfolioDetail;
}

export async function approvePortfolio(
	id: string,
	notes?: string,
): Promise<ReviewablePortfolio> {
	const trimmedNotes = notes?.trim();
	const response = await apiClient.post(
		`/api/v1/admin/portfolios/${id}/verify`,
		{ ...(trimmedNotes ? { notes: trimmedNotes } : {}) },
	);
	return response.data.data.portfolio as ReviewablePortfolio;
}

export async function rejectPortfolio(
	id: string,
	reason: string,
): Promise<ReviewablePortfolio> {
	const response = await apiClient.post(
		`/api/v1/admin/portfolios/${id}/reject`,
		{ reason: reason.trim() },
	);
	return response.data.data.portfolio as ReviewablePortfolio;
}
